module.exports = __webpack_public_path__ + "media/I.9878048c.mp3";